export const SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE';
export const GET_CLIENTS_BEGIN = 'GET_CLIENTS_BEGIN';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_ERROR = 'GET_CLIENTS_ERROR';
export const GET_SINGLE_CLIENT_BEGIN = 'GET_SINGLE_CLIENT_BEGIN';
export const GET_SINGLE_CLIENT_SUCCESS = 'GET_SINGLE_CLIENT_SUCCESS';
export const GET_SINGLE_CLIENT_ERROR = 'GET_SINGLE_CLIENT_ERROR';
export const SEARCH_CLIENTS = 'SEARCH_CLIENTS';
export const SAVE_CLIENTS = 'SAVE_CLIENTS';
export const EDIT_CLIENTS = 'EDIT_CLIENTS';
export const REFRESH_CLIENTS = 'REFRESH_CLIENTS';
export const ADD_TO_INVOICE = 'ADD_TO_INVOICE';
export const REMOVE_INVOICE_ITEM = 'REMOVE_INVOICE_ITEM';
export const TOGGLE_INVOICE_ITEM_AMOUNT = 'TOGGLE_INVOICE_ITEM_AMOUNT';
export const CLEAR_INVOICE = 'CLEAR_INVOICE';
export const COUNT_INVOICE_TOTALS = 'COUNT_INVOICE_TOTALS';
